export default __webpack_public_path__ + "daf1b68692642e531fc5d28507ecc475.png";